import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../components/Helpers/helpers";

export const userListApi = createApi({
  reducerPath: "userListApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),

  tagTypes: ["Users"],

  endpoints: (builder) => ({
    
    //  GET ALL USERS
    getAllUsers: builder.query({
      query: () =>         `/invoice/getAllUsers?OrganisationID=${localStorage.getItem("OrganisationID")}`,
      providesTags: ["Users"],
    }),

  }),
});

export const {
  useGetAllUsersQuery,
} = userListApi;